import { FormControl, InputLabel, Select, MenuItem, type SelectChangeEvent } from '@mui/material';

export interface TimeRange {
  key: string;
  label: string;
  resolution: string;
}

export interface TimeRangeSelectorProps {
  timeRanges: TimeRange[];
  value: string;
  onChange: (key: string) => void;
}

export function TimeRangeSelector({ timeRanges, value, onChange }: TimeRangeSelectorProps) {
  const handleChange = (e: SelectChangeEvent<string>) => {
    onChange(e.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 160 }}>
      <InputLabel id="time-range-label">Time Range</InputLabel>
      <Select
        labelId="time-range-label"
        value={value}
        label="Time Range"
        onChange={handleChange}
      >
        {timeRanges.map((tr) => (
          <MenuItem key={tr.key} value={tr.key}>
            {tr.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
